module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_0.a4c5190c.png";